var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.0685 5.7139C15.4505 5.09592 14.4484 5.09477 13.8301 5.71404L5.29271 14.2506C4.8408 14.7025 4.58691 15.3154 4.58691 15.9545C4.58691 17.2852 5.66571 18.364 6.99642 18.364C7.63545 18.364 8.24833 18.1101 8.70021 17.6582L17.237 9.12146C17.8555 8.50293 17.8555 7.50088 17.237 6.88235L16.0685 5.7139ZM14.8916 6.77388C14.923 6.74242 14.9747 6.74144 15.0079 6.77456L16.1763 7.94301C16.2091 7.97575 16.2091 8.02806 16.1763 8.0608L7.63955 16.5976C7.46898 16.7681 7.23764 16.864 6.99642 16.864C6.49411 16.864 6.08691 16.4568 6.08691 15.9545C6.08691 15.7133 6.18275 15.4819 6.35332 15.3114L14.8916 6.77388Z",
    fill: "inherit"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.5039 16.6953C11.0897 16.6953 10.7539 17.0311 10.7539 17.4453C10.7539 17.8595 11.0897 18.1953 11.5039 18.1953H18.4939C18.9081 18.1953 19.2439 17.8595 19.2439 17.4453C19.2439 17.0311 18.9081 16.6953 18.4939 16.6953H11.5039Z",
    fill: "inherit"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.f9754be7d31855e5f1021da3f26a32f7.svg";
export { ForwardRef as ReactComponent };